// extracted by mini-css-extract-plugin
module.exports = {"WhyItWorks":"_2teWZDGN","Container":"_201aLOZk","Wrapper":"_2VA1wgdQ","Column1":"_3EZlPuIu","SecondaryTitle":"_2gSPjQG5","Description":"ltkebS0-","Column2":"_2bunPKw8","Image":"_218X0pAP","SecondaryTitle2":"jpcgbKV3","jobBoardsTable":"_20tCbLqZ","underline":"_3jekoxNr"};
    if(module.hot) {
      // 1746735782580
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  